import React, { useMemo } from 'react'
import { getReadableNumber } from 'src/helpers/getReadableNumber'
import { useErc20Balance } from 'src/hooks/useErc20Balance'
import { CurveService } from 'src/services/CurveService'
import { InfoBox } from '../InfoBox'

interface IProps {
  curveService: CurveService
}

export function DepositInfo({ curveService }: IProps) {
  const lpTokenBalance = useErc20Balance(curveService.lpToken.address, curveService.signer)
  const infos = useMemo(
    () => [
      {
        property: 'Your balance',
        value: `${getReadableNumber(lpTokenBalance)} STABLEx3CRV`,
        tooltip: 'Your balance of LP tokens',
      },
      {
        property: 'Max Slippage',
        value: '2%',
        tooltip: 'Max difference between expected and returned amount of target token',
      },
    ],
    [lpTokenBalance],
  )
  return <InfoBox infos={infos} />
}
